import { Component, Input } from 'angular-ts-decorators';

import { forEach } from 'lodash';

import { Language } from '@shared/app/scripts/services/language';

/**
 * Displays all languages for which we have translations, and allow
 * user to choose one.
 *
 * ## Usage
 * <pre>
 *   <sw-translation-picker></sw-translation-picker>
 * </pre>
 */
@Component({
  selector: 'swTranslationPicker',
  template: require('./sw-translation-picker.html').default,
})
export class SwTranslationPickerComponent {
  @Input('@') dropUp: any;

  toggleAllLanguages: boolean;
  languages: string[];

  languageCodes = {};

  constructor(
    private language: Language,
    private languageNames,
  ) {
    'ngInject';
  }

  ngOnInit() {
    forEach(this.languageNames, (entry) => {
      this.languageCodes[entry.code] = entry.name;
    });

    this.toggleAllLanguages = false;

    this.languages = this.language.getAll();
  }

  // Note! This doesn't fix cases where in one country is more then one language.
  getCountryFlag(languageId) {
    const match = languageId.match(/\w\w-(\w\w)/);

    if (match && match.length > 1) {
      return match[1];
    }

    return languageId;
  }

  // callback for clicked element
  clicked(languageId) {
    this.toggleAllLanguages = false;
    if (this.language.current !== languageId) {
      this.language.set(languageId);
    }
  }

  /**
   * Get the current selected language
   * @return {String}
   * Current language identifier
   */
  getCurrentLanguage() {
    return this.language.current;
  }

  /**
   * Get classes for the language button.
   * @param {string} languageId
   * Language id
   * @return {Object}
   * Object that contains classes as keys
   */
  getClasses(languageId) {
    // TODO in case of performance issues, replace function with classes data
    const classes = {
      current: this.language.current === languageId,
    };

    classes['flag-icon-' + this.getCountryFlag(languageId)] = true;

    return classes;
  }

  /**
   * Returns the language name loaded form {@link
   * sharedModule.languageNames languageNames}
   * @param {string} languageId
   * Language id
   * @returns {string}
   * Language name in English
   */
  getLanguageName(languageId) {
    return this.languageCodes[languageId];
  }
}
